// extracted by mini-css-extract-plugin
export var layoutWrapper = "layout-module--layoutWrapper--1eGXI";